module.exports = __webpack_public_path__ + "static/media/Lato-Semibold.3c6cfb1a.ttf";